module.exports = __webpack_public_path__ + "static/media/android_consulting.ad4a7935.jpg";